/* eslint-disable arrow-body-style */

import React, { useEffect } from 'react';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { scroll2Module as scroll2ModuleGameDetail } from '../GameDetail/utils';
import { scroll2Module as scroll2ModuleFinance } from '../Finance/utils';
import { scroll2Module as scroll2ModuleStakeholder } from '../Stakeholder/utils';
import { PROJECT_DETAIL_STORAGE_KEY } from '@gp/constants/storageKeys';

import type { IRecord } from '@gp/types/global';

const scroll2ModuleActionMapping: IRecord<(rootNode?: HTMLElement | null, moduleKey?: string) => void> = {
  gameDetail: scroll2ModuleGameDetail,
  finance: scroll2ModuleFinance,
  stakeholder: scroll2ModuleStakeholder,
};

export default function useAutoScroll2TargetModule(props: {
  pageContainer?: React.RefObject<HTMLElement | null>;
  loading: boolean;
}) {
  const { pageContainer, loading } = props;

  useEffect(() => {
    if (loading) return;
    const initialTab = storage.getSessionStorageItem(
      PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_PROJECT_DETAIL_TAB_STORAGE_KEY,
      true,
    );
    const initialModuleKey = storage.getSessionStorageItem(
      PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_PROJECT_DETAIL_TAB_MODULE_STORAGE_KEY,
      true,
    );
    if (!!initialTab && !!initialModuleKey) {
      const scroll2Module = scroll2ModuleActionMapping[initialTab];
      scroll2Module?.(pageContainer?.current, initialModuleKey);
    }
  }, [loading]);
}
